{
  "home": {
    "listen1": "Votre bulletin.",
    "listen2": "Solution de numérisation."
  }
}
